import { Navigate, Outlet, useParams } from 'react-router';

import { useSession } from '~entities/session';

import { Loading } from '../Loading';

export function RedirectIfAuthenticated() {
  const { pharmacyId } = useParams<{ pharmacyId: string }>();

  const { session, isPending } = useSession(pharmacyId);

  if (isPending) {
    return <Loading />;
  }

  if (session?.user) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
